<template>
    <v-dialog
        :value="value"
        max-width="600px"
        persistent
        @keydown.esc="emitClose"
        @click:outside="emitClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Wybierz składki dla komponentu
                    <span v-if="componentName" class="font-weight-medium">: {{ componentName }}</span>
                </h1>
            </v-card-title>

            <v-card-text style="max-height:60vh;overflow-y:auto;">
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th style="width:40px;" />
                            <th>
                                Składka
                            </th>
                            <th class="text-center" style="width:90px;">
                                Nakład
                            </th>
                            <th class="text-center" style="width:140px;">
                                Wadliwy nakład
                            </th>
                            <th class="text-center" style="width:120px;">
                                Wadliwy nakład w %
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="!localSignatures.length">
                            <td colspan="5" class="text-center grey--text">
                                Brak składek do wyświetlenia
                            </td>
                        </tr>
                        <tr v-for="sig in localSignatures" :key="sig.signatureNumber">
                            <td>
                                <v-checkbox v-model="sig.selected" class="ma-0 pa-0" hide-details />
                            </td>
                            <td>
                                Składka {{ sig.signatureNumber }}
                            </td>
                            <td class="text-center">
                                {{ sig.signatureAmount }}
                            </td>
                            <td class="text-center" style="vertical-align:middle;">
                                <v-text-field
                                    v-model.number="sig.defectiveAmount"
                                    type="number"
                                    dense
                                    :disabled="!sig.selected"
                                    :min="0"
                                    :error="isDefectiveGreater(sig) || getDefectiveError(sig).length > 0"
                                    :error-messages="getDefectiveError(sig)"
                                    :hide-details="getDefectiveError(sig).length === 0"
                                    style="max-width:110px;"
                                    @input="onSignatureDefectiveInput(sig)"
                                />
                            </td>
                            <td class="text-center">
                                <span>{{ formatPercent(sig.defectiveAmountPercent) }}</span>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn text color="error" @click="emitClose">
                    Anuluj
                </v-btn>

                <v-spacer />

                <v-btn text color="success" :disabled="saveDisabled" @click="emitSave">
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
/* eslint-disable vue/no-mutating-props */

export default {
    name: 'SelectSignaturesDialog',

    props: {
        value: { 
            type: Boolean
        },
        signatures: {
            type: Array,
            default: () => []
        },
        componentName: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            localSignatures: []
        }
    },

    computed: {
        saveDisabled() {
            return this.localSignatures.some(sig => Number(sig.defectiveAmount) > sig.signatureAmount)
        }
    },

    watch: {
        value(val) {
            if (val) this.initialize()
        }
    },

    methods: {
        initialize() {
            this.localSignatures = this.signatures.map(signature => ({ ...signature }))
        },

        isDefectiveGreater(sig) {
            if (sig.defectiveAmount === '' || sig.defectiveAmount === null) return false

            return Number(sig.defectiveAmount) > sig.signatureAmount
        },

        getDefectiveError(sig) {
            if (sig.defectiveAmount === '' || sig.defectiveAmount === null) return []
            const val = Number(sig.defectiveAmount)

            if (val < 0 || val > sig.signatureAmount) {
                return ['Podaj wartość w zakresie 0 - ' + sig.signatureAmount]
            }

            return []
        },

        emitClose() {
            this.$emit('on-close')
        },

        emitSave() {
            const selected = this.localSignatures.filter(signature => signature.selected && signature.defectiveAmount > 0 && signature.defectiveAmount <= signature.signatureAmount)

            this.$emit('on-save', selected)
        },

        onSignatureDefectiveInput(signature) {
            if (signature.defectiveAmount === '' || signature.defectiveAmount === null || Number.isNaN(Number(signature.defectiveAmount))) {
                signature.defectiveAmount = 0
                signature.defectiveAmountPercent = null

                return
            }
            if (signature.defectiveAmount < 0) signature.defectiveAmount = 0

            if (Number(signature.defectiveAmount) > signature.signatureAmount) {
                signature.defectiveAmountPercent = null
                if (signature.defectiveAmount > 0) signature.selected = true

                return
            }
            const max = Number(signature.signatureAmount) || 0

            signature.defectiveAmountPercent = signature.defectiveAmount > 0 && max ? ((signature.defectiveAmount / max) * 100).toFixed(1) : null
            if (signature.defectiveAmount > 0) signature.selected = true
        },

        formatPercent(value) {
            if (value === null || value === undefined || value === '') return ''
            const num = Number(value)

            if (Number.isNaN(num)) return '%'

            return num.toFixed(1) + '%'
        }
    }
}
</script>
